// Node listesi
export const GET_NODES_SERVICE_REQUEST = "GET_NODES_SERVICE_REQUEST";
export const GET_NODES_SERVICE_SUCCESS = "GET_NODES_SERVICE_SUCCESS";
export const GET_NODES_SERVICE_FAILURE = "GET_NODES_SERVICE_FAILURE";

// Tek bir node getirme
export const GET_NODE_BY_ID_SERVICE_REQUEST = "GET_NODE_BY_ID_SERVICE_REQUEST";
export const GET_NODE_BY_ID_SERVICE_SUCCESS = "GET_NODE_BY_ID_SERVICE_SUCCESS";
export const GET_NODE_BY_ID_SERVICE_FAILURE = "GET_NODE_BY_ID_SERVICE_FAILURE";

// Node durumu güncelleme
export const UPDATE_NODE_STATUS_SERVICE_REQUEST = "UPDATE_NODE_STATUS_SERVICE_REQUEST";
export const UPDATE_NODE_STATUS_SERVICE_SUCCESS = "UPDATE_NODE_STATUS_SERVICE_SUCCESS";
export const UPDATE_NODE_STATUS_SERVICE_FAILURE = "UPDATE_NODE_STATUS_SERVICE_FAILURE";

// Node silme
export const DELETE_NODE_SERVICE_REQUEST = "DELETE_NODE_SERVICE_REQUEST";
export const DELETE_NODE_SERVICE_SUCCESS = "DELETE_NODE_SERVICE_SUCCESS";
export const DELETE_NODE_SERVICE_FAILURE = "DELETE_NODE_SERVICE_FAILURE";

// CheckHealth 
export const CHECK_NODE_HEALTH_SERVICE_REQUEST = 'CHECK_NODE_HEALTH_SERVICE_REQUEST';
export const CHECK_NODE_HEALTH_SERVICE_SUCCESS = 'CHECK_NODE_HEALTH_SERVICE_SUCCESS';
export const CHECK_NODE_HEALTH_SERVICE_FAILURE = 'CHECK_NODE_HEALTH_SERVICE_FAILURE';

// Action Creators
export const getNodesServiceRequest = (params) => ({
  type: GET_NODES_SERVICE_REQUEST,
  payload: params,
});

export const getNodeByIdServiceRequest = (id) => ({
  type: GET_NODE_BY_ID_SERVICE_REQUEST,
  payload: id,
});

export const updateNodeStatusServiceRequest = (id, status) => ({
  type: UPDATE_NODE_STATUS_SERVICE_REQUEST,
  payload: { id, status },
});

export const deleteNodeServiceRequest = (id) => ({
  type: DELETE_NODE_SERVICE_REQUEST,
  payload: id,
});

export const checkNodeHealthServiceRequest = (attributes) => ({
  type: CHECK_NODE_HEALTH_SERVICE_REQUEST,
  payload: attributes,
});